"use client";

import { c as _c } from "react/compiler-runtime";
import FullPageOverlay from 'src/components/fullpageoverlay/FullPageOverlay';
import TwentyThreeTrailerPlayer from "src/components/traileroverlaywrapper/TwentyThreeTrailerPlayer";
import YoutubeTrailerPlayer from "src/components/traileroverlaywrapper/YoutubeTrailerPlayer";
import type IFilmklipp from "src/lib/types/Filmklipp";
import type { ITrailer } from "src/lib/types/Trailer";
const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

//#region [Props]
type TrailerOverlayWrapperProps = {
  video?: ITrailer | IFilmklipp;
  videoId?: number | string; // 23 video id or youtube id
  title?: string; // should be used when videoId is used for youtube
  onClose: () => void;
  hideRelated?: boolean;
  onSelectTrailer?: (newTrailerId: number) => void;
};
//#endregion

//#region [Component]
export default function TrailerOverlayWrapper(t0) {
  const $ = _c(13);
  const {
    video,
    onClose,
    videoId,
    hideRelated: t1,
    onSelectTrailer,
    title
  } = t0;
  const hideRelated = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== hideRelated || $[1] !== onSelectTrailer || $[2] !== video || $[3] !== videoId) {
    t2 = BRAND === "filmweb" && <TwentyThreeTrailerPlayer video={video} videoId={Number(videoId)} hideRelated={hideRelated} onSelectTrailer={onSelectTrailer} />;
    $[0] = hideRelated;
    $[1] = onSelectTrailer;
    $[2] = video;
    $[3] = videoId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== title || $[6] !== video || $[7] !== videoId) {
    t3 = BRAND === "kinodk" && <YoutubeTrailerPlayer video={video} videoId={videoId as (string | undefined)} title={title} />;
    $[5] = title;
    $[6] = video;
    $[7] = videoId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== onClose || $[10] !== t2 || $[11] !== t3) {
    t4 = <FullPageOverlay onClose={onClose}>{t2}{t3}</FullPageOverlay>;
    $[9] = onClose;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
//#endregion